import type {z} from "zod";

import {UpdateRepresentativeBody} from "@project/sdk/sales/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {representativeFieldLabelIds} from "../../../messages/representatives.messages";

const updateCompany = UpdateRepresentativeBody.shape.company;
const updateProfile = updateCompany.shape.partyProfile;
const updatePhone = updateProfile.shape.phone;

export const updateRepresentativeAddressSchema = requiredStringSchema(
  updateProfile.shape.address.shape.address,
  representativeFieldLabelIds.address,
);
export const updateRepresentativeCompanyNameSchema = requiredStringSchema(
  updateCompany.shape.companyName,
  representativeFieldLabelIds.companyName,
);
export const updateRepresentativeCompanyIdSchema = requiredStringSchema(
  updateCompany.shape.companyId,
  representativeFieldLabelIds.companyId,
);

export const updateRepresentativeFormSchema = zod.object({
  companyId: updateRepresentativeCompanyIdSchema,
  companyName: updateRepresentativeCompanyNameSchema,
  address: updateRepresentativeAddressSchema,
  country: updateProfile.shape.country,
  phoneNumber: updatePhone.shape.nationalNumber,
  phonePrefix: updatePhone.shape.regionCode,
  websiteUrl: updateProfile.shape.websiteUrl,
  logoUrl: UpdateRepresentativeBody.shape.logoUrl,
  exclusive: UpdateRepresentativeBody.shape.exclusive,
});
export type UpdateRepresentativeFormPayload = z.output<typeof updateRepresentativeFormSchema>;

export const draftUpdateRepresentativeFormSchema = updateRepresentativeFormSchema.partial();
export type DraftUpdateRepresentativeFormPayload = z.output<
  typeof draftUpdateRepresentativeFormSchema
>;
